/*
*
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
* and other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the applicable
* third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
* and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
* form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or 
* otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
* prosecuted to the maximum extent possible under the law.
* 
*/
import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../../services/profile.service';
import { environment } from '../../../../environments/environment';
import { HeaderService } from '../../services/header.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-switcher',
    templateUrl: './app-switcher.component.html',
    styleUrls: ['./app-switcher.component.scss'],
    standalone: false
})
export class AppSwitcherComponent implements OnInit {
  profile: any;
  item: any;
  appList: any;
  isAppSwitcherEnabled: boolean = false;
  constructor(private router: Router, private _headerService: HeaderService, private _profileService: ProfileService) { }

  ngOnInit(): void {
      this.profile = this._profileService.fetchProfile();
    this.appList = this.profile.apps;
    this._profileService.getUIconfig().toPromise()
      .then(uiConfig => {
        if (uiConfig && typeof uiConfig.isAppSwitcherEnabled !== 'undefined' && uiConfig.isAppSwitcherEnabled) {
          this.isAppSwitcherEnabled = true;
        }
      }).catch(err => {
        console.log(err);
      });
  }

  getClass(index) {
    return 'color' + index % 4;
  }

  goToApp(item) {
    this._headerService.hideIconsOverlay();
    this.router.navigate([this.router.url]);
    if (this.isAppSwitcherEnabled) {
      var url = `${environment.baseContext}` + '/' + this.profile.client_code.toLowerCase() + "/" + item.appPath;
      window.location.href = url;
    } else {
      this.router.navigate([item.appPath]);
    }
  }
}


